import { render, staticRenderFns } from "./PlayerVideo.vue?vue&type=template&id=c2ae8bf2&scoped=true"
import script from "./PlayerVideo.vue?vue&type=script&lang=js"
export * from "./PlayerVideo.vue?vue&type=script&lang=js"
import style0 from "./PlayerVideo.vue?vue&type=style&index=0&id=c2ae8bf2&prod&lang=stylus&scoped=true"
import style1 from "./PlayerVideo.vue?vue&type=style&index=1&id=c2ae8bf2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae8bf2",
  null
  
)

export default component.exports